import { render, staticRenderFns } from "./TableGoleadores.vue?vue&type=template&id=7426aff9&scoped=true&"
import script from "./TableGoleadores.vue?vue&type=script&lang=js&"
export * from "./TableGoleadores.vue?vue&type=script&lang=js&"
import style0 from "./TableGoleadores.vue?vue&type=style&index=0&id=7426aff9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7426aff9",
  null
  
)

export default component.exports